import { Button, Image } from '@mantine/core';
import * as React from 'react';

import Stub from '../Stub';

import img from './image.svg';

type EmptyStubProps = {
  fullHeight?: boolean;
  className?: string;
  title: string;
  onReset?: () => void;
  hasFilters?: boolean;
  onActionButtonClick?: () => void;
  actionButtonText?: string;
};

const EmptyStub: React.FC<EmptyStubProps> = ({
  className,
  fullHeight,
  onReset,
  title,
  hasFilters,
  onActionButtonClick,
  actionButtonText,
}) => {
  const action = React.useMemo(() => {
    if (hasFilters && onReset) {
      return (
        <Button size="sm" variant="light" onClick={onReset}>
          Сбросить
        </Button>
      );
    }

    if (!hasFilters && onActionButtonClick) {
      return (
        <Button size="sm" fw="400" variant="light" onClick={onActionButtonClick}>
          {actionButtonText}
        </Button>
      );
    }

    return null;
  }, [hasFilters, onReset, onActionButtonClick, actionButtonText]);

  return (
    <Stub
      fullHeight={fullHeight}
      className={className}
      title={title}
      icon={<Image src={img} w={185} h={117} alt="Пустая коробка" />}
      action={action}
    />
  );
};

export default React.memo(EmptyStub);
